import styled from 'styled-components';
import ElectricSmokeDetectorIconSvg from '../../assets/hotels/amenities/ElectricSmokeDetector.svg';

const ElectricSmokeDetectorIcon = styled(
  ElectricSmokeDetectorIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ElectricSmokeDetectorIcon;
